/**
 * Bonded Matter — Mobile sticky Filter & Sort CTA visibility.
 *
 * Figma M/Collection §2.1 — the sticky `Filter & Sort` pill is a convenience
 * anchor for the product grid. It should only appear while the grid itself
 * is in the viewport; hidden before the user scrolls down to the grid and
 * hidden again once the grid scrolls past above the fold.
 *
 * Desktop (>= 768px) keeps the inline 72×29 toolbar button and is never
 * touched by this script.
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 767.98px)';
  var VISIBLE_CLASS = 'is-sticky-visible';
  var DATA_INIT = 'bmFacetStickyInit';

  function queryPairs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wrappers = scope.querySelectorAll(
      '.shopify-section.collection-section .facet-drawer-wrapper'
    );
    var pairs = [];
    wrappers.forEach(function (wrapper) {
      var section = wrapper.closest('.shopify-section.collection-section');
      if (!section) return;
      // Prefer the explicit grid wrapper; fall back to the section so we
      // still hide the CTA inside the footer/recommendations.
      var target = section.querySelector('#ProductGridWrapper') || section;
      pairs.push({ wrapper: wrapper, target: target });
    });
    return pairs;
  }

  function init(root) {
    var mql = window.matchMedia(MOBILE_MQ);
    var pairs = queryPairs(root);
    if (!pairs.length) return;

    pairs.forEach(function (pair) {
      var wrapper = pair.wrapper;
      var target = pair.target;

      // Clean any previous observer so re-init after `shopify:section:load`
      // (theme editor) doesn't stack duplicates.
      if (wrapper.__bmFacetSticky) {
        wrapper.__bmFacetSticky.disconnect();
        wrapper.__bmFacetSticky = null;
      }
      wrapper.classList.remove(VISIBLE_CLASS);

      if (!mql.matches) return;
      if (!('IntersectionObserver' in window)) {
        // Defensive fallback: always-visible on mobile browsers without IO.
        wrapper.classList.add(VISIBLE_CLASS);
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              wrapper.classList.add(VISIBLE_CLASS);
            } else {
              wrapper.classList.remove(VISIBLE_CLASS);
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px 0px 0px' }
      );
      io.observe(target);
      wrapper.__bmFacetSticky = io;
      wrapper.dataset[DATA_INIT] = 'true';
    });

    // Breakpoint changes: re-evaluate so rotating into desktop clears state
    // and back into mobile re-attaches the observer.
    if (!init.__bmMqlBound) {
      var onChange = function () { init(document); };
      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', onChange);
      } else if (typeof mql.addListener === 'function') {
        mql.addListener(onChange);
      }
      init.__bmMqlBound = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    init(ev.target || document);
  });
})();
